import 'bootstrap-sass';
import 'modernizr';

import ExternalLinks from './external_links';

function ready() {
  const externalLinks = new ExternalLinks();
  externalLinks.init();

  /**
   * Activate Bootstrap popover
   */
  if (window.innerWidth > 1024) {
    $('[data-toggle="popover"]').popover();
  }

  /**
   * Automatically instantiates modules based on data-attributes specifying
   * module file-names.
   */
  const moduleElements = document.querySelectorAll('[data-module]');

  for (let i = 0; i < moduleElements.length; i += 1) {
    const el = moduleElements[i];
    const name = el.getAttribute('data-module');
    const Module = require(`./${name}`).default; // eslint-disable-line global-require, import/no-dynamic-require

    new Module(el); // eslint-disable-line no-new
  }
}

// in case the document is already rendered
if (document.readyState !== 'loading') {
  ready();
} else {
  document.addEventListener('DOMContentLoaded', ready);
}



// WEBPACK FOOTER //
// ./src/main/javascripts/modules/index.js